export const getLEtoileData = () => ({
  name: "L'Étoile",
  region: "Jura",
  country: "France",
  description: "L'Étoile est une petite appellation prestigieuse du Jura, réputée pour ses vins blancs de garde et son vin de paille. Cette sous-région tire son nom des fossiles d'étoiles de mer présents dans ses sols marneux. L'Étoile produit des vins d'une grande finesse et d'une longue garde, dans un microclimat favorable à la pourriture noble.",
  type: "subregion",
  area: "60 hectares",
  production: "2,500 hectolitres",
  climate: "Semi-continental avec microclimat favorable",
  soil: "Marnes grises avec fossiles d'étoiles de mer",
  characteristics: {
    "Terroir": "Marnes grises du Jurassique avec fossiles d'étoiles de mer",
    "Climat": "Microclimat favorable à la pourriture noble",
    "Altitude": "250-350 mètres",
    "Exposition": "Sud et sud-est, protégée des vents"
  },
  grapeVarieties: {
    "Blancs": {
      "Chardonnay": {
        description: "Cépage principal pour les vins blancs secs",
        characteristics: "Acidité vive, notes minérales, arômes de fruits blancs",
        wineStyle: "Vins blancs secs et aromatiques de garde"
      },
      "Savagnin": {
        description: "Cépage emblématique du Jura, base du vin de paille",
        characteristics: "Acidité élevée, potentiel oxydatif, arômes complexes",
        wineStyle: "Vin de paille, vins blancs secs"
      },
      "Poulsard (blanc)": {
        description: "Poulsard vinifié en blanc, spécialité de L'Étoile",
        characteristics: "Couleur claire, arômes délicats, acidité fraîche",
        wineStyle: "Vins blancs légers et aromatiques"
      }
    }
  },
  wineStyles: {
    "Blanc": "Vins blancs secs et minéraux, avec une grande longévité. Les Chardonnay et Savagnin expriment parfaitement le terroir unique de L'Étoile.",
    "Vin de Paille": "Vin liquoreux rare et précieux, produit à partir de raisins séchés sur paille pendant 2-3 mois. Notes de fruits secs, miel, épices.",
    "Vin Jaune": "Vin blanc oxydatif élevé sous voile de levures, bien que moins courant qu'à Château-Chalon."
  },
  vinification: {
    "Vin de Paille": {
      "Récolte": "Vendanges manuelles, raisins surmûris",
      "Séchage": "2-3 mois sur paille ou claies",
      "Pressurage": "Pressurage doux, moût concentré",
      "Fermentation": "Fermentation lente et contrôlée",
      "Élevage": "18-24 mois en fûts de chêne"
    },
    "Vins Blancs": {
      "Pressurage": "Pressurage doux, débourbage naturel",
      "Fermentation": "Fermentation en fûts de chêne",
      "Élevage": "12-18 mois sur lies fines"
    }
  },
  statistics: {
    "Surface": "60 hectares",
    "Production": "2,500 hectolitres",
    "Nombre de domaines": "10+",
    "Vin de Paille": "Production très limitée",
    "Garde potentielle": "20+ ans pour les vins blancs"
  },
  history: "L'Étoile tire son nom des fossiles d'étoiles de mer présents dans ses sols marneux du Jurassique. La viticulture y remonte à l'époque romaine. Au Moyen Âge, les moines ont développé la production de vin de paille. L'appellation L'Étoile a été créée en 1937, reconnaissant l'excellence de ce terroir unique. Aujourd'hui, L'Étoile reste une appellation de référence pour les vins blancs du Jura.",
  foodPairing: "Poissons nobles (truite, sandre), crustacés, volaille de Bresse, foie gras, desserts aux fruits secs, fromages affinés (Comté, Morbier). Le vin de paille de L'Étoile est parfait avec les desserts et les fromages bleus."
}); 